import { MutationTree } from 'vuex';
import { CastListState } from '@/store/types';
import { ICast } from '@/types/cast';

const mutations: MutationTree<CastListState> = {
    setCastList(state, castData: ICast[]) {
        state.castList = castData;
    },
    setNewCommerList(state, castData: ICast[]) {
        state.newCommerList = castData;
    }
};

export default mutations;